(function () {
  function initFooterNewsletterConsent(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.newsletter-form');

    forms.forEach(function (form) {
      if (form.dataset.newsletterConsentInit === 'true') {
        return;
      }

      var checkbox = form.querySelector('[data-footer-newsletter-consent-checkbox]');
      var submitButton = form.querySelector('button[type="submit"]');

      if (!checkbox || !submitButton) {
        return;
      }

      function syncButtonState() {
        submitButton.disabled = !checkbox.checked;
      }

      syncButtonState();
      checkbox.addEventListener('change', syncButtonState);
      form.dataset.newsletterConsentInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFooterNewsletterConsent(document);
    });
  } else {
    initFooterNewsletterConsent(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooterNewsletterConsent(event.target);
  });
})();
